import React from 'react'

import { useTheme } from 'styled-components'

import { Avatar } from '@components/Avatar'
import { useDate } from '@hooks/dates'
import { useNames } from '@hooks/names'

import {
  CommentContainer,
  Container,
  Info,
  UserName,
  DateLabel,
  CommentBox,
} from './styles'
import { NoComments } from '../NoComments'

interface IDisplayComments {
  comment: string
  createdOn: Date
  id: number
  user: {
    firstName: string
    lastName: string
  }
}

interface IProps {
  comments: IDisplayComments[]
}

export function CommentsList({ comments }: IProps) {
  const { formatDate } = useDate()
  const { concatenateName } = useNames()
  const theme = useTheme()

  const sortedComments = comments.sort(
    (a, b) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime(),
  )

  function formatCommentDate(date: Date) {
    const formattedDate = formatDate(new Date(date)).dateLong
    const formattedHour = formatDate(new Date(date)).time

    return `${formattedDate}${' at '}${formattedHour}`
  }

  return (
    <>
      {comments?.length ? (
        sortedComments.map((item) => (
            <Container key={item.id}>
              <Avatar width={40} height={40}>
                {item.user.firstName?.slice(0, 1)}
              </Avatar>
              <CommentContainer>
                <CommentBox>
                  <UserName>
                    {concatenateName(item.user?.firstName, item.user?.lastName)}
                  </UserName>
                  <Info>{item.comment}</Info>
                </CommentBox>
                <DateLabel>{formatCommentDate(item.createdOn)}</DateLabel>
              </CommentContainer>
            </Container>
        ))
      ) : (
        <NoComments backgroundColor={theme.colors.background}>
          No comments yet, be the first one.
        </NoComments>
      )}
    </>
  )
}
